import { render, staticRenderFns } from "./CommandTypeForm.vue?vue&type=template&id=31e582aa"
import script from "./CommandTypeForm.vue?vue&type=script&lang=js"
export * from "./CommandTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports